// FUNCTION TO INSERT CURRENT DATE IN INPUTS [TYPE=DATE] EXCEPT IN NAME='DATA_NASCIMENTO'
export function controlDate() {
  const ignoreCases = ['data_nascimento'];
  const date = new Date();

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const currentDate = `${year}-${month}-${day}`;

  const inputDate = document.querySelectorAll('input[type="date"]')

  inputDate.forEach((input) => {
    if (ignoreCases.includes(input.name)) return;

    input.value = currentDate;
    input.min = currentDate;

    input.addEventListener('blur', () => {
      if(input.value < currentDate) {
        input.value = currentDate;
      }
    });
  });
}
